"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  imageSrc?: FieldConfig;
  title?: FieldConfig;
  slug?: string;
  className?: string;
  imageMetadata?: ImageMetadata;
};
export default function ImageText(t0) {
  const $ = _c(24);
  const {
    imageSrc: t1,
    title: t2,
    slug,
    className: t3,
    imageMetadata
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const imageSrc = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "\u0BB0\u0B9C\u0BBF\u0BA9\u0BBF - 75",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const title = t5;
  const className = t3 === undefined ? "" : t3;
  let t6;
  if ($[4] !== imageSrc?.value) {
    t6 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[4] = imageSrc?.value;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const imageSrcValue = t6;
  const titleValue = title?.value || "";
  const t7 = `bg-white overflow-hidden border-2 border-012061 flex flex-col ${className}`;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: "228px",
      height: "377px"
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== imageMetadata || $[8] !== imageSrc?.customClass || $[9] !== imageSrc?.hidden || $[10] !== imageSrcValue || $[11] !== titleValue) {
    t9 = !imageSrc?.hidden && <div className="relative flex-1"><div className={`border-b-4 border-012061 p-2 h-full ${imageSrc?.customClass || ""}`}><div className="relative w-full h-full overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading="lazy" sizes="228px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div></div>;
    $[7] = imageMetadata;
    $[8] = imageSrc?.customClass;
    $[9] = imageSrc?.hidden;
    $[10] = imageSrcValue;
    $[11] = titleValue;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== title?.customClass || $[14] !== title?.hidden || $[15] !== titleValue) {
    t10 = !title?.hidden && <div className={`bg-012061 p-4 ${title?.customClass || ""}`}><h3 className="text-white font-tamil text-12-tamil-700 text-center">{titleValue}</h3></div>;
    $[13] = title?.customClass;
    $[14] = title?.hidden;
    $[15] = titleValue;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== t9) {
    t11 = <article className={t7} style={t8}>{t9}{t10}</article>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const content = t11;
  if (slug) {
    let t12;
    if ($[21] !== content || $[22] !== slug) {
      t12 = <Link href={slug} className="block hover:opacity-90 transition-opacity">{content}</Link>;
      $[21] = content;
      $[22] = slug;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    return t12;
  }
  return content;
}